import { Component, OnInit, OnDestroy } from '@angular/core';
import { CardGradingService } from './services/card-grading.service';
import { OrderService } from '../orders/services/order.service';
import { CheckoutService } from '../checkout/services/checkout.service';

@Component({
    selector: 'app-sgc-card-grading',
    templateUrl: './card-grading.component.html',
    standalone: false
})
export class CardGradingComponent implements OnInit, OnDestroy {
  constructor(
    private orderService: OrderService,
    private checkoutService: CheckoutService,
    private cardGradingService: CardGradingService
  ) {}

  ngOnInit() {
    this.cardGradingService.activateSubMenu();
    this.orderService.checkBusinessDayGur().subscribe((adminKPIExecutive) => {
      this.checkoutService.newGuranteeDaysMsg(adminKPIExecutive);
    });
  }

  ngOnDestroy() {
    this.cardGradingService.deactivateSubMenu();
  }
}
